import React from "react";
import "./Lyndon.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Lyndon12images from "../../../Media/BSD/Navapark/Lyndon12";
import Lyndon15images from "../../../Media/BSD/Navapark/Lyndon15";
import Lyndon19images from "../../../Media/BSD/Navapark/Lyndon19";

const imageMap = {
  Lyndon12images,
  Lyndon15images,
  Lyndon19images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Wynyard" className="Wynyard">
      <h1>Welcome to Lyndon</h1>
      <h2>Cicilan Start 86 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
